import { HTTP } from "@/helpers/http-common"

const url = "/api/reporteexclusiones"

const list = (data) => new Promise((resolve, reject) => {
  HTTP.post(`${url}/list`, data
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const report = (data) => new Promise((resolve, reject) => {
  HTTP.post(`${url}/report`, data, { responseType: "blob", timeout: 6000000 }
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

export default {
  list
  , report
}


// WEBPACK FOOTER //
// ./src/services/reportes/reporteexclusiones/index.js